import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useThemeStore } from '../../store/themeStore';

const ThemeSync = () => {
  const location = useLocation();
  const { isDarkMode } = useThemeStore();

  useEffect(() => {
    const path = location.pathname;
    
    // Define dashboard/authenticated paths that should support dark mode
    const isDashboardPath = 
      path.startsWith('/admins') || 
      path.startsWith('/clients') || 
      path.startsWith('/hellocians') ||
      path === '/notifications' ||
      path.startsWith('/today-gigs');

    // Categorize public paths explicitly
    const isPublicPath = 
      path === '/' ||
      path.startsWith('/about-us') ||
      path.startsWith('/contact-us') ||
      path.startsWith('/terms-of-services') ||
      path.startsWith('/privacy-policy') ||
      path.startsWith('/refund-policy') ||
      path.startsWith('/disclaimer') ||
      path.startsWith('/help-center') ||
      path.startsWith('/services') ||
      path.startsWith('/hire-talents') ||
      path.startsWith('/gigs/') ||
      path.startsWith('/category/') ||
      path.startsWith('/project-submission') ||
      path.startsWith('/tutorials') ||
       path.startsWith('/how-it-works');

    // Auth pages should also stay light (consistent with public design)
    const isAuthPage = 
      path.includes('/signin') || 
      path.includes('/signup') || 
      path.includes('/forgot-password') || 
      path.includes('/reset-password') ||
      path.includes('/activate') ||
      path.includes('/setup-password');

    // Only apply dark mode if 
    // 1. User has it enabled 
    // 2. We are NOT on a public page or auth page
    const shouldBeDark = isDarkMode && !isPublicPath && !isAuthPage;

    if (shouldBeDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [location.pathname, isDarkMode]);

  return null;
};

export default ThemeSync;
